import { mapStores } from 'pinia'
import useBcStorageExplorerStore from '@/frontapp/store/bcStorageExplorer'

export default {
  props: {
    selectedItems: Object,
  },
  computed: {
    ...mapStores(useBcStorageExplorerStore),
  },
  methods: {
    selectItem(item, options) {
      if (
        !options.isShift || 
        this.bcStorageExplorerStore.previousItemSelectedIndex === null
      ) {
        this.selectedItems.set(item.id, item)
        this.bcStorageExplorerStore.previousItemSelectedIndex = options.itemIndex

        return
      }

      // multiple shift select
      const direction = options.itemIndex > this.bcStorageExplorerStore.previousItemSelectedIndex ? 1 : -1
      const startIndex = this.bcStorageExplorerStore.previousItemSelectedIndex + direction
      const endIndex = options.itemIndex
      const modal = document.querySelector('.ModalAside--Opened')

      for (
        let currentIndex = startIndex;
        direction > 0 ? currentIndex <= endIndex : currentIndex >= endIndex;
        currentIndex += direction
      ) {
        const element = modal.querySelector('[data-modal-item-index="' + currentIndex + '"]')
        const itemId = element.item.id
        
        if (!this.selectedItems.has(itemId)) {
          this.selectItem(
            element.item, 
            {
              ...options, 
              ...{
                isShift: false,
                itemIndex: currentIndex,
              }
            }
          )
        }
      }
    },
    unselectItem(itemId) {
      this.selectedItems.delete(itemId)
      if (this.selectedItems.size) {
        this.bcStorageExplorerStore.previousItemSelectedIndex = null
      }
    },
  },
}
